import { observer } from "mobx-react-lite";
import { runInAction } from "mobx";
import { useOrderFormState } from "@boundary/_hooks/useOrderFormState";
import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { ServiceOption } from "@boundary/components/serviceOption";
import { useDebouncedPriceCalculation } from "@boundary/_hooks/useDebouncedPriceCalculation";
import styles from "./duplexSelect.module.scss";

interface DuplexSelectProps {
  vm: ReturnType<typeof useOrderFormState>;
}

export const DuplexSelect = observer(function DuplexSelect({ vm }: DuplexSelectProps) {
  if (!vm.currentFile || !vm.currentService) return null;
  if (!vm.currentFile.id || !vm.currentFile.previewUrl) return null;

  const file = vm.currentFile;
  const calculatePrice = useDebouncedPriceCalculation(vm);

  if (!getInfoByService(vm.currentService.type).duplexAvailable) return null;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Способ печати</h2>
      <div className={styles.options}>
        <ServiceOption
          value={!file.duplexOption}
          onChange={() => {
            runInAction(() => {
              file.duplexOption = false;
            });
            calculatePrice();
          }}
        >
          Односторонняя печать
        </ServiceOption>
        <ServiceOption
          value={file.duplexOption}
          onChange={() => {
            runInAction(() => {
              file.duplexOption = true;
            });
            calculatePrice();
          }}
        >
          Двухсторонняя печать
        </ServiceOption>
      </div>
    </div>
  );
});

